import { render, staticRenderFns } from "./PurchaseInvoicePayDetail.vue?vue&type=template&id=52025de3&"
import script from "./PurchaseInvoicePayDetail.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicePayDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports